import { Grid } from "@mui/material";
import { Custom } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { Feedback } from "types";
import { Constants, Enums, Helpers } from "utils";

type Props = {
  email: string;
  onSubmit: (patientId: number) => void;
};

export const QioskForm = (props: Props) => {
  const { setFeedback, service, t, theme } = useApp();

  const initialState = {
    firstName: "",
    lastName: "",
    phone: "",
  };

  const { onChange, onSubmit, values } = useForm(submitCallback, initialState);

  async function submitCallback() {
    const { firstName, lastName, phone }: any = values;
    if (Helpers.hasValue(firstName, lastName, props.email, phone)) {
      const response = await service.patient.registerAtQiosk(
        `${firstName},${lastName}`,
        props.email,
        phone
      );
      if (response) {
        setFeedback({
          message: t.message.qiosk.check_in_no_account,
          severity: Enums.EnumFeedback.Success,
        } as Feedback);
        props.onSubmit && props.onSubmit(response);
      }
    }
  }

  return (
    <form onSubmit={onSubmit} className="qh-form">
      <Grid container spacing={theme.margin.sm}>
        <Grid item xs={12} sm={6}>
          <Custom.TextField
            name="lastName"
            focused={true}
            required={true}
            onChange={onChange}
            label={t.label.last_name}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Custom.TextField
            name="firstName"
            required={true}
            onChange={onChange}
            label={t.label.first_name}
          />
        </Grid>
        <Grid item xs={12}>
          <Custom.TextField
            name="phone"
            required={true}
            onChange={onChange}
            label={t.label.phone}
            mask={Constants.INPUT_MASK.PHONE}
          />
        </Grid>
        <Grid item xs={12}>
          <div className="qh-control">
            <Custom.Button
              sx={{ width: "100%", height: 58, fontSize: theme.font.lg }}
              submit
            >
              {t.action.submit}
            </Custom.Button>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};
